import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-crm-tipo-procedure',
  templateUrl: './crm-tipo-procedure.component.html',
  styleUrls: ['./crm-tipo-procedure.component.css']
})
export class CrmTipoProcedureComponent implements OnInit {


  @Input() titolo:string;

  constructor() { }

  ngOnInit() {
  }

}
